export enum LocalizedComponentName {
    SharedMessages = "shared-messages",
    Notifications = "notifications",
    ValidationMessages = "validation-messages",
    AccountTypes = "account-types",
    StartReleaseRequest = "release-request-initiation",
    ResolutionPanel = "resolution-panel",
    ResolutionPanelReleaseRequests = "resolution-panel-release-requests",
    ReleaseRequestDetails = "release-request-details",
    ReleaseRequestDetailsTenancyTab = "release-request-details-tenancy-tab",
    ReleaseRequestDetailsCaseNotesTab = "release-request-details-case-notes-tab",
    ReleaseRequestOverview = "release-request-overview",
    ReleaseRequestSelectOnBehalfOfDialog = "release-request-select-on-behalf-of-dialog",
    SettlementForm = "settlement-form",
    StartReleaseRequestChooseProperty = "release-request-initiation-choose-property",
    StartReleaseRequestAddDocument = "release-request-initiation-add-documents",
    StartReleaseRequestConfirmation = "release-request-initiation-confirmation",
    SignUpEnterEmail = "sign-up-enter-email",
    SignUpEnterFirstAndLastName = "sign-up-first-and-last-name",
    SignUpCheckInbox = "sign-up-check-inbox",
    SignUpAccountType = "sign-up-account-type",
    SignInEnterEmail = "sign-in-enter-email",
    SignInHeaderSignUp = "sign-in-header-sign-up",
    SignInAuthWay = "sign-in-auth-way",
    SignInCheckInbox = "sign-in-check-inbox",
    SignInPhoneCode = "sign-in-phone-code",
    StartReleaseRequestAddSettlement = "release-request-initiation-add-settlements",
    SettlementTypes = "settlement-types",
    ReleaseRequestStatuses = "release-request-statuses",
    CommonDataGrid = "common-data-grid",
    SignUpPhoneNumber = "sign-up-phone-number",
    SignUpSmsCode = "sign-up-sms-code",
    ContinueSignUpPage = "continue-sign-up-page",
    AccessErrorPage = "error-403",
    InternalErrorPage = "error-500",
    NotFoundErrorPage = "error-404",
    RegistrationExpiredLinkErrorPage = "registration-link-expired",
    ConfirmationExpiredLinkErrorPage = "confirmation-link-expired",
    AgentAccountFinish = "sign-up-agent-finish",
    CompanyDetailsAndAddress = "sign-up-agent-details",
    CorporateLLDetails = "sign-up-corporate-landlord-details",
    CorporateLLFinish = "sign-up-corporate-landlord-finish",
    PrivateLLFinish = "sign-up-landlord-finish",
    InternalUserFinish = "sign-up-internal-user-finish",
    TenantFinish = "sign-up-tenant-finish",
    HonestyQuestions = "honesty-questions-links",
    NavMenu = "nav-menu",
    PrivacyPolicyAndTermsAndConditionsConfirmDialog = "privacy-policy-and-terms-and-conditions-confirm-dialog",
    MyProfile = "my-profile",
    EmploymentStatuses = "employment-statuses",
    SettlementStatuses = "settlement-statuses",
    AdminFinanceFailedPayment = "adm-finance-failed-payment",
    AdminFinanceVouchers = "adm-finance-vouchers",
    VouchersUsageMetrics = "vouchers-usage-metrics",
    AdminSettingsInternalUsers = "adm-settings-internal-users",
    AdminSettingsRates = "adm-settings-rates",
    AdminSettingsPortal = "adm-settings-portal",
    AdminSettingsInvitation = "adm-settings-invitation",
    AdminUsersList = "adm-users-list",
    AdminCreateUser = "adm-create-user",
    AdminBusiness = "adm-businesses",
    StaffList = "staff-list",
    StaffUser = "staff-user",
    StaffPage = "staff-page",
    StaffRoles = "staff-roles",
    CompanyUserRoles = "company-user-roles",
    UserStatuses = "user-statuses",
    ProposeNewSettlements = "propose-settlements-form",
    CompanyFormAddress = "company-form-address",
    Chat = "chat",
    Gallery = "gallery",
    AgencyBranches = "agency-branches",
    CompanyDetails = "company-details",
    CompanyFormDetails = "company-form-details",
    FooterLabelsLinks = "footer-labels-links",
    UsersInvitation = "users-invitation",
    InviteRevoked = "invite-revoked",
    ExpiredInviteLink = "expired-invite-link",
    TenantMyHome = "tenant-my-home",
    Permissions = "permissions",
    PermissionGroups = "permission-groups",
    UserProfileByInternalUser = "profile-for-internal-user",
    InternalUserProfile = "internal-user-profile",
    UserActionsToolbar = "profile-actions-toolbar",
    UserProfileHeadingToolbar = "profile-heading-toolbar",
    LandlordProperties = "landlord-properties",
    LandlordAddProperty = "landlord-add-property",
    AdminCompanyDetails = "adm-company-details",
    DeactivationReasons = "deactivation-reasons",
    AddPropertyAgencyForm = "add-property-agency-form",
    BulkPropertiesUpload = "bulk-properties-upload",
    TenancyStatuses = "tenancy-statuses",
    TenantBilling = "tenant-billings",
    ClaimStart = "claim-start",
    ClaimStartAddSettlements = "claim-start-add-settlements",
    ClaimStartViewAgreements = "claim-start-view-agreements",
    ClaimMakeDecision = "claim-make-decision",
    Dashboard = "dashboard",
    PropertyDetails = "property-details",
    NotificationsModal = "notifications-modal",
    ResolutionManagementClaimDetails = "resolution-management-claim-details",
    ResolutionManagementClaimsList = "resolution-management-claims-list",
    PropertiesEndOfTenancy = "properties-end-of-tenancy",
    PropertyMembership = "property-membership",
    Membership = "membership",
    EndOfTenancyConfirmation = "end-of-tenancy-confirmation",
    AuditActionTypes = "audit-action-types",
    AuditObjectTypes = "audit-object-types",
    Activity = "activity",
    MissingDetails = "missing-details",
    PdfLoader = "pdf-loader",
}
